import { Star } from 'lucide-react'

import { cn } from '@/lib/utils'

interface RatingStarsProps {
    rating: number
    className?: string
    size?: 'sm' | 'md'
}

export const RatingStars = ({ rating, className, size = 'sm' }: RatingStarsProps) => (
    <div className={cn('flex items-center gap-0.5', className)} role='img' aria-label={`Rated ${rating} out of 5`}>
        {[1, 2, 3, 4, 5].map(value => (
            <Star
                key={value}
                aria-hidden='true'
                className={cn(
                    size === 'sm' ? 'size-4' : 'size-5',
                    value <= rating ? 'fill-gold-400 text-gold-400' : 'fill-transparent text-gold-300/60'
                )}
            />
        ))}
    </div>
)
